// Thin wrapper so the Salesforce components can use the app's existing axios
// instance (pass it as `apiClient`) or fall back to fetch + the stored JWT.
// Same-origin: Nginx serves the app and proxies /api, so this never depends on a hardcoded IP.
const BASE = '';

function fallbackClient() {
  const req = async (method, url, body) => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch (_) { /* ignore */ }
    const res = await fetch(`${BASE}${url}`, {
      method,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.message || `HTTP ${res.status}`);
      err.response = { status: res.status, data };
      throw err;
    }
    return { data };
  };
  return { get: (u) => req('GET', u), post: (u, b) => req('POST', u, b) };
}

export function getClient(apiClient) {
  return apiClient || fallbackClient();
}

// axios instances usually already have baseURL ending in /api; fetch fallback does not.
export function sfPath(apiClient, path) {
  const hasApiBase = apiClient && apiClient.defaults && /\/api\/?$/.test(apiClient.defaults.baseURL || '');
  return `${hasApiBase ? '' : '/api'}/salesforce${path}`;
}

let configPromise = null;
export function loadSfConfig(apiClient) {
  if (!configPromise) {
    configPromise = getClient(apiClient)
      .get(sfPath(apiClient, '/config'))
      .then((r) => r.data)
      .catch(() => {
        configPromise = null;
        return { enabled: false, canPush: false, promptStatuses: [], picklists: {} };
      });
  }
  return configPromise;
}

export function errorMessage(err) {
  return (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || 'Something went wrong';
}
